import React from 'react';
import Image from 'next/image';
import styles from './hera-page-admin.module.css';
import admin from '../../public/hera/admin/admin.png';
import { Container, Htag, HtagVariant, Paragraph } from '../../components';

export default function HeraPageAdmin() {
  return (
    <section className={styles.admin}>
      <Container>
        <Htag className={styles.admin_title} variant={HtagVariant.h3}>
          ADMIN PANEL
        </Htag>
        <Paragraph className={styles.admin_text}>
          Сustom admin panel was designed and developed so the admins could
          upload and organise a bunch of content, assign meals, workouts,
          healthcare information, articles and tips for every week of
          woman&apos;s period.
        </Paragraph>
        <Image
          alt="Hera app admin panel"
          src={admin}
          width={1450}
          height={956}
        />
      </Container>
    </section>
  );
}
